// Routes owned by the Jobs module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const jobsPaths = {
    // Unreferenced: no paths.* caller; route is live (/jobs/:jobID).
    jobEdit: '/jobs/:jobID',
    jobCreate: '/jobs/new',
    jobList: '/jobs',
} as const
